var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _g, _path416, _g2, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNearBy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M403.488 80.4451H301.48C301.48 80.4451 311.594 52.8201 327.16 52.8201C342.726 52.8201 347.602 71.8881 347.602 71.8881C347.602 71.8881 358.104 61.5281 366.731 61.5281C375.358 61.5281 382.859 75.2181 382.859 75.2181C382.859 75.2181 395.049 67.8561 403.488 80.4451Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M451.034 109.93H403.363C403.363 109.93 414.015 94.4971 422.407 94.4971C430.799 94.4971 433.279 104.786 433.279 104.786C433.279 104.786 439.202 99.9841 444.689 100.842C450.176 101.7 451.034 109.93 451.034 109.93Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M354.353 167.338H306.682C306.682 167.338 317.334 151.905 325.726 151.905C334.118 151.905 336.598 162.194 336.598 162.194C336.598 162.194 342.521 157.393 348.008 158.25C353.496 159.107 354.353 167.338 354.353 167.338Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.82 179.201H48.966C48.966 179.201 61.682 150.813 75.285 149.038C88.888 147.264 95.393 170.132 95.393 170.132C95.393 170.132 104.166 162.049 111.066 162.049C117.966 162.049 123.289 172.695 123.289 172.695C123.289 172.695 137.089 165.4 141.82 179.201Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M184.226 95.7691H121.501C121.501 95.7691 132.275 75.2012 143.964 74.9022C155.653 74.6022 161.797 90.4682 161.797 90.4682C161.797 90.4682 179.98 75.8751 184.226 95.7691Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M285.013 193.621H247.729V389.061H285.013V193.621Z",
    fill: "#DBDBDB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M260.764 199.969H253.516V207.431H260.764V199.969Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M270.036 199.969H262.788V207.431H270.036V199.969Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M260.764 212.639H253.516V220.102H260.764V212.639Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M270.036 212.639H262.788V220.102H270.036V212.639Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M260.764 225.309H253.516V232.772H260.764V225.309Z",
    fill: "#EBEBEB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M270.036 225.309H262.788V232.772H270.036V225.309Z",
    fill: "#EBEBEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M260.764 237.978H253.516V245.441H260.764V237.978Z",
    fill: "#EBEBEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M270.036 237.978H262.788V245.441H270.036V237.978Z",
    fill: "#EBEBEB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M260.764 250.648H253.516V258.111H260.764V250.648Z",
    fill: "#EBEBEB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M270.036 250.648H262.788V258.111H270.036V250.648Z",
    fill: "#EBEBEB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M260.764 263.318H253.516V270.781H260.764V263.318Z",
    fill: "#EBEBEB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M270.036 263.318H262.788V270.781H270.036V263.318Z",
    fill: "#EBEBEB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M260.764 275.988H253.516V283.45H260.764V275.988Z",
    fill: "#EBEBEB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M270.036 275.988H262.788V283.45H270.036V275.988Z",
    fill: "#EBEBEB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M260.764 288.657H253.516V296.119H260.764V288.657Z",
    fill: "#EBEBEB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M270.036 288.657H262.788V296.119H270.036V288.657Z",
    fill: "#EBEBEB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M260.764 301.327H253.516V308.79H260.764V301.327Z",
    fill: "#EBEBEB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M270.036 301.327H262.788V308.79H270.036V301.327Z",
    fill: "#EBEBEB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M260.764 313.997H253.516V321.46H260.764V313.997Z",
    fill: "#EBEBEB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M270.036 313.997H262.788V321.46H270.036V313.997Z",
    fill: "#EBEBEB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M260.764 326.666H253.516V334.129H260.764V326.666Z",
    fill: "#EBEBEB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M270.036 326.666H262.788V334.129H270.036V326.666Z",
    fill: "#EBEBEB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M260.764 339.336H253.516V346.799H260.764V339.336Z",
    fill: "#EBEBEB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M270.036 339.336H262.788V346.799H270.036V339.336Z",
    fill: "#EBEBEB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M260.764 352.006H253.516V359.469H260.764V352.006Z",
    fill: "#EBEBEB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M270.036 352.006H262.788V359.469H270.036V352.006Z",
    fill: "#EBEBEB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M260.764 364.675H253.516V372.138H260.764V364.675Z",
    fill: "#EBEBEB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M271.978 372.138H279.226V364.675H271.978V372.138Z",
    fill: "#EBEBEB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M271.978 359.468H279.226V352.005H271.978V359.468Z",
    fill: "#EBEBEB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M271.978 346.799H279.226V339.336H271.978V346.799Z",
    fill: "#EBEBEB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M271.978 334.129H279.226V326.666H271.978V334.129Z",
    fill: "#EBEBEB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M271.978 321.459H279.226V313.996H271.978V321.459Z",
    fill: "#EBEBEB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M271.978 308.789H279.226V301.326H271.978V308.789Z",
    fill: "#EBEBEB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M271.978 296.12H279.226V288.658H271.978V296.12Z",
    fill: "#EBEBEB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M271.978 283.45H279.226V275.988H271.978V283.45Z",
    fill: "#EBEBEB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M271.978 270.78H279.226V263.317H271.978V270.78Z",
    fill: "#EBEBEB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M271.978 258.111H279.226V250.648H271.978V258.111Z",
    fill: "#EBEBEB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M271.978 245.441H279.226V237.978H271.978V245.441Z",
    fill: "#EBEBEB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M271.978 232.771H279.226V225.308H271.978V232.771Z",
    fill: "#EBEBEB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M271.978 220.102H279.226V212.639H271.978V220.102Z",
    fill: "#EBEBEB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M271.978 207.432H279.226V199.97H271.978V207.432Z",
    fill: "#EBEBEB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M270.036 364.675H262.788V372.138H270.036V364.675Z",
    fill: "#EBEBEB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M314.409 193.621H285.013V389.061H314.409V193.621Z",
    fill: "#A6A6A6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M305.394 372.138H311.379V364.675H305.394V372.138Z",
    fill: "#C7C7C7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M297.738 372.138H303.723V364.675H297.738V372.138Z",
    fill: "#C7C7C7"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M305.394 359.468H311.379V352.005H305.394V359.468Z",
    fill: "#C7C7C7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M297.738 359.468H303.723V352.005H297.738V359.468Z",
    fill: "#C7C7C7"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M305.394 346.799H311.379V339.336H305.394V346.799Z",
    fill: "#C7C7C7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M297.738 346.799H303.723V339.336H297.738V346.799Z",
    fill: "#C7C7C7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M305.394 334.129H311.379V326.666H305.394V334.129Z",
    fill: "#C7C7C7"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M297.738 334.129H303.723V326.666H297.738V334.129Z",
    fill: "#C7C7C7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M305.394 321.459H311.379V313.996H305.394V321.459Z",
    fill: "#C7C7C7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M297.738 321.459H303.723V313.996H297.738V321.459Z",
    fill: "#C7C7C7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M305.394 308.789H311.379V301.326H305.394V308.789Z",
    fill: "#C7C7C7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M297.738 308.789H303.723V301.326H297.738V308.789Z",
    fill: "#C7C7C7"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M305.394 296.12H311.379V288.658H305.394V296.12Z",
    fill: "#C7C7C7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M297.738 296.12H303.723V288.658H297.738V296.12Z",
    fill: "#C7C7C7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M305.394 283.45H311.379V275.988H305.394V283.45Z",
    fill: "#C7C7C7"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M297.738 283.45H303.723V275.988H297.738V283.45Z",
    fill: "#C7C7C7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M305.394 270.78H311.379V263.317H305.394V270.78Z",
    fill: "#C7C7C7"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M297.738 270.78H303.723V263.317H297.738V270.78Z",
    fill: "#C7C7C7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M305.394 258.111H311.379V250.648H305.394V258.111Z",
    fill: "#C7C7C7"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M297.738 258.111H303.723V250.648H297.738V258.111Z",
    fill: "#C7C7C7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M305.394 245.441H311.379V237.978H305.394V245.441Z",
    fill: "#C7C7C7"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M297.738 245.441H303.723V237.978H297.738V245.441Z",
    fill: "#C7C7C7"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M305.394 232.771H311.379V225.308H305.394V232.771Z",
    fill: "#C7C7C7"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M297.738 232.771H303.723V225.308H297.738V232.771Z",
    fill: "#C7C7C7"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M305.394 220.102H311.379V212.639H305.394V220.102Z",
    fill: "#C7C7C7"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M297.738 220.102H303.723V212.639H297.738V220.102Z",
    fill: "#C7C7C7"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M305.394 207.432H311.379V199.97H305.394V207.432Z",
    fill: "#C7C7C7"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M296.132 199.969H290.147V207.431H296.132V199.969Z",
    fill: "#C7C7C7"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M296.132 212.639H290.147V220.102H296.132V212.639Z",
    fill: "#C7C7C7"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M296.132 225.309H290.147V232.772H296.132V225.309Z",
    fill: "#C7C7C7"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M296.132 237.978H290.147V245.441H296.132V237.978Z",
    fill: "#C7C7C7"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M296.132 250.648H290.147V258.111H296.132V250.648Z",
    fill: "#C7C7C7"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M296.132 263.318H290.147V270.781H296.132V263.318Z",
    fill: "#C7C7C7"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M296.132 275.988H290.147V283.45H296.132V275.988Z",
    fill: "#C7C7C7"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M296.132 288.657H290.147V296.119H296.132V288.657Z",
    fill: "#C7C7C7"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M296.132 301.327H290.147V308.79H296.132V301.327Z",
    fill: "#C7C7C7"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M296.132 313.997H290.147V321.46H296.132V313.997Z",
    fill: "#C7C7C7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M296.132 326.666H290.147V334.129H296.132V326.666Z",
    fill: "#C7C7C7"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M296.132 339.336H290.147V346.799H296.132V339.336Z",
    fill: "#C7C7C7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M296.132 352.006H290.147V359.469H296.132V352.006Z",
    fill: "#C7C7C7"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M296.132 364.675H290.147V372.138H296.132V364.675Z",
    fill: "#C7C7C7"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M297.738 207.432H303.723V199.97H297.738V207.432Z",
    fill: "#C7C7C7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M150.965 189.356H112.071V389.061H150.965V189.356Z",
    fill: "#EBEBEB"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M150.966 185.38H111.136V189.357H150.966V185.38Z",
    fill: "#C7C7C7"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M119.529 195.218H115.588V389.062H119.529V195.218Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M126.509 195.218H122.568V389.062H126.509V195.218Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 195.218H129.548V389.062H133.488V195.218Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M140.468 195.218H136.528V389.062H140.468V195.218Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M147.449 195.218H143.508V389.062H147.449V195.218Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M119.529 200.242H115.588V208.092H119.529V200.242Z",
    fill: "#EBEBEB"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M126.509 200.242H122.568V208.092H126.509V200.242Z",
    fill: "#EBEBEB"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 200.242H129.548V208.092H133.488V200.242Z",
    fill: "#EBEBEB"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M140.468 200.242H136.528V208.092H140.468V200.242Z",
    fill: "#EBEBEB"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M147.449 200.242H143.508V208.092H147.449V200.242Z",
    fill: "#EBEBEB"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M119.529 213.001H115.588V220.851H119.529V213.001Z",
    fill: "#EBEBEB"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M126.509 213.001H122.568V220.851H126.509V213.001Z",
    fill: "#EBEBEB"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 213.001H129.548V220.851H133.488V213.001Z",
    fill: "#EBEBEB"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M140.468 213.001H136.528V220.851H140.468V213.001Z",
    fill: "#EBEBEB"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M147.449 213.001H143.508V220.851H147.449V213.001Z",
    fill: "#EBEBEB"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M119.529 225.759H115.588V233.609H119.529V225.759Z",
    fill: "#EBEBEB"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M126.509 225.759H122.568V233.609H126.509V225.759Z",
    fill: "#EBEBEB"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 225.759H129.548V233.609H133.488V225.759Z",
    fill: "#EBEBEB"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M140.468 225.759H136.528V233.609H140.468V225.759Z",
    fill: "#EBEBEB"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M147.449 225.759H143.508V233.609H147.449V225.759Z",
    fill: "#EBEBEB"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M119.529 238.517H115.588V246.367H119.529V238.517Z",
    fill: "#EBEBEB"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M126.509 238.517H122.568V246.367H126.509V238.517Z",
    fill: "#EBEBEB"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 238.517H129.548V246.367H133.488V238.517Z",
    fill: "#EBEBEB"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M140.468 238.517H136.528V246.367H140.468V238.517Z",
    fill: "#EBEBEB"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M147.449 238.517H143.508V246.367H147.449V238.517Z",
    fill: "#EBEBEB"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M119.529 251.276H115.588V259.126H119.529V251.276Z",
    fill: "#EBEBEB"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M126.509 251.276H122.568V259.126H126.509V251.276Z",
    fill: "#EBEBEB"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 251.276H129.548V259.126H133.488V251.276Z",
    fill: "#EBEBEB"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M140.468 251.276H136.528V259.126H140.468V251.276Z",
    fill: "#EBEBEB"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M147.449 251.276H143.508V259.126H147.449V251.276Z",
    fill: "#EBEBEB"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M119.529 264.034H115.588V271.884H119.529V264.034Z",
    fill: "#EBEBEB"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M126.509 264.034H122.568V271.884H126.509V264.034Z",
    fill: "#EBEBEB"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 264.034H129.548V271.884H133.488V264.034Z",
    fill: "#EBEBEB"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M140.468 264.034H136.528V271.884H140.468V264.034Z",
    fill: "#EBEBEB"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M147.449 264.034H143.508V271.884H147.449V264.034Z",
    fill: "#EBEBEB"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M119.529 276.792H115.588V284.642H119.529V276.792Z",
    fill: "#EBEBEB"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M126.509 276.792H122.568V284.642H126.509V276.792Z",
    fill: "#EBEBEB"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 276.792H129.548V284.642H133.488V276.792Z",
    fill: "#EBEBEB"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M140.468 276.792H136.528V284.642H140.468V276.792Z",
    fill: "#EBEBEB"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M147.449 276.792H143.508V284.642H147.449V276.792Z",
    fill: "#EBEBEB"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M119.529 289.551H115.588V297.401H119.529V289.551Z",
    fill: "#EBEBEB"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M126.509 289.551H122.568V297.401H126.509V289.551Z",
    fill: "#EBEBEB"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 289.551H129.548V297.401H133.488V289.551Z",
    fill: "#EBEBEB"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M140.468 289.551H136.528V297.401H140.468V289.551Z",
    fill: "#EBEBEB"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M147.449 289.551H143.508V297.401H147.449V289.551Z",
    fill: "#EBEBEB"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M119.529 302.309H115.588V310.159H119.529V302.309Z",
    fill: "#EBEBEB"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M126.509 302.309H122.568V310.159H126.509V302.309Z",
    fill: "#EBEBEB"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 302.309H129.548V310.159H133.488V302.309Z",
    fill: "#EBEBEB"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M140.468 302.309H136.528V310.159H140.468V302.309Z",
    fill: "#EBEBEB"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M147.449 302.309H143.508V310.159H147.449V302.309Z",
    fill: "#EBEBEB"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M119.529 315.067H115.588V322.917H119.529V315.067Z",
    fill: "#EBEBEB"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M126.509 315.067H122.568V322.917H126.509V315.067Z",
    fill: "#EBEBEB"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 315.067H129.548V322.917H133.488V315.067Z",
    fill: "#EBEBEB"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M140.468 315.067H136.528V322.917H140.468V315.067Z",
    fill: "#EBEBEB"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M147.449 315.067H143.508V322.917H147.449V315.067Z",
    fill: "#EBEBEB"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M119.529 327.826H115.588V335.676H119.529V327.826Z",
    fill: "#EBEBEB"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M126.509 327.826H122.568V335.676H126.509V327.826Z",
    fill: "#EBEBEB"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 327.826H129.548V335.676H133.488V327.826Z",
    fill: "#EBEBEB"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M140.468 327.826H136.528V335.676H140.468V327.826Z",
    fill: "#EBEBEB"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M147.449 327.826H143.508V335.676H147.449V327.826Z",
    fill: "#EBEBEB"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M119.529 340.584H115.588V348.434H119.529V340.584Z",
    fill: "#EBEBEB"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M126.509 340.584H122.568V348.434H126.509V340.584Z",
    fill: "#EBEBEB"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 340.584H129.548V348.434H133.488V340.584Z",
    fill: "#EBEBEB"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M140.468 340.584H136.528V348.434H140.468V340.584Z",
    fill: "#EBEBEB"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M147.449 340.584H143.508V348.434H147.449V340.584Z",
    fill: "#EBEBEB"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M119.529 353.342H115.588V361.192H119.529V353.342Z",
    fill: "#EBEBEB"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M126.509 353.342H122.568V361.192H126.509V353.342Z",
    fill: "#EBEBEB"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 353.342H129.548V361.192H133.488V353.342Z",
    fill: "#EBEBEB"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M140.468 353.342H136.528V361.192H140.468V353.342Z",
    fill: "#EBEBEB"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M147.449 353.342H143.508V361.192H147.449V353.342Z",
    fill: "#EBEBEB"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M119.529 366.1H115.588V389.061H119.529V366.1Z",
    fill: "#EBEBEB"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M126.509 366.1H122.568V389.061H126.509V366.1Z",
    fill: "#EBEBEB"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 366.1H129.548V389.061H133.488V366.1Z",
    fill: "#EBEBEB"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M140.468 366.1H136.528V389.061H140.468V366.1Z",
    fill: "#EBEBEB"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M147.449 366.1H143.508V389.061H147.449V366.1Z",
    fill: "#EBEBEB"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M175.936 189.356H150.966V389.061H175.936V189.356Z",
    fill: "#DBDBDB"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M177.017 185.38H150.966V189.357H177.017V185.38Z",
    fill: "#C7C7C7"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M158.423 195.218H154.482V389.062H158.423V195.218Z",
    fill: "#C7C7C7"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M165.403 195.218H161.462V389.062H165.403V195.218Z",
    fill: "#C7C7C7"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M172.384 195.218H168.443V389.062H172.384V195.218Z",
    fill: "#C7C7C7"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M158.423 200.242H154.482V208.092H158.423V200.242Z",
    fill: "#DBDBDB"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M165.403 200.242H161.462V208.092H165.403V200.242Z",
    fill: "#DBDBDB"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M172.384 200.242H168.443V208.092H172.384V200.242Z",
    fill: "#DBDBDB"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M158.423 213.001H154.482V220.851H158.423V213.001Z",
    fill: "#DBDBDB"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M165.403 213.001H161.462V220.851H165.403V213.001Z",
    fill: "#DBDBDB"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M172.384 213.001H168.443V220.851H172.384V213.001Z",
    fill: "#DBDBDB"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M158.423 225.759H154.482V233.609H158.423V225.759Z",
    fill: "#DBDBDB"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M165.403 225.759H161.462V233.609H165.403V225.759Z",
    fill: "#DBDBDB"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M172.384 225.759H168.443V233.609H172.384V225.759Z",
    fill: "#DBDBDB"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M158.423 238.517H154.482V246.367H158.423V238.517Z",
    fill: "#DBDBDB"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M165.403 238.517H161.462V246.367H165.403V238.517Z",
    fill: "#DBDBDB"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M172.384 238.517H168.443V246.367H172.384V238.517Z",
    fill: "#DBDBDB"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M158.423 251.276H154.482V259.126H158.423V251.276Z",
    fill: "#DBDBDB"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M165.403 251.276H161.462V259.126H165.403V251.276Z",
    fill: "#DBDBDB"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M172.384 251.276H168.443V259.126H172.384V251.276Z",
    fill: "#DBDBDB"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M158.423 264.034H154.482V271.884H158.423V264.034Z",
    fill: "#DBDBDB"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M165.403 264.034H161.462V271.884H165.403V264.034Z",
    fill: "#DBDBDB"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M172.384 264.034H168.443V271.884H172.384V264.034Z",
    fill: "#DBDBDB"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M158.423 276.792H154.482V284.642H158.423V276.792Z",
    fill: "#DBDBDB"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M165.403 276.792H161.462V284.642H165.403V276.792Z",
    fill: "#DBDBDB"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M172.384 276.792H168.443V284.642H172.384V276.792Z",
    fill: "#DBDBDB"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M158.423 289.551H154.482V297.401H158.423V289.551Z",
    fill: "#DBDBDB"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M165.403 289.551H161.462V297.401H165.403V289.551Z",
    fill: "#DBDBDB"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M172.384 289.551H168.443V297.401H172.384V289.551Z",
    fill: "#DBDBDB"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M158.423 302.309H154.482V310.159H158.423V302.309Z",
    fill: "#DBDBDB"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M165.403 302.309H161.462V310.159H165.403V302.309Z",
    fill: "#DBDBDB"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M172.384 302.309H168.443V310.159H172.384V302.309Z",
    fill: "#DBDBDB"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M158.423 315.067H154.482V322.917H158.423V315.067Z",
    fill: "#DBDBDB"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M165.403 315.067H161.462V322.917H165.403V315.067Z",
    fill: "#DBDBDB"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M172.384 315.067H168.443V322.917H172.384V315.067Z",
    fill: "#DBDBDB"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M158.423 327.826H154.482V335.676H158.423V327.826Z",
    fill: "#DBDBDB"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M165.403 327.826H161.462V335.676H165.403V327.826Z",
    fill: "#DBDBDB"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M172.384 327.826H168.443V335.676H172.384V327.826Z",
    fill: "#DBDBDB"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M158.423 340.584H154.482V348.434H158.423V340.584Z",
    fill: "#DBDBDB"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M165.403 340.584H161.462V348.434H165.403V340.584Z",
    fill: "#DBDBDB"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M172.384 340.584H168.443V348.434H172.384V340.584Z",
    fill: "#DBDBDB"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M158.423 353.342H154.482V361.192H158.423V353.342Z",
    fill: "#DBDBDB"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M165.403 353.342H161.462V361.192H165.403V353.342Z",
    fill: "#DBDBDB"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M172.384 353.342H168.443V361.192H172.384V353.342Z",
    fill: "#DBDBDB"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M158.423 366.1H154.482V389.061H158.423V366.1Z",
    fill: "#DBDBDB"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M165.403 366.1H161.462V389.061H165.403V366.1Z",
    fill: "#DBDBDB"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M172.384 366.1H168.443V389.061H172.384V366.1Z",
    fill: "#DBDBDB"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M94.527 249.168H57.64V389.061H94.527V249.168Z",
    fill: "#EBEBEB"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M94.527 239.89H62.887V249.168H94.527V239.89Z",
    fill: "#C7C7C7"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M90.483 254.011H61.685V358.59H90.483V254.011Z",
    fill: "#DBDBDB"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M90.483 263.991H61.685V266.462H90.483V263.991Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M90.483 274.228H61.685V276.699H90.483V274.228Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M90.483 284.464H61.685V286.935H90.483V284.464Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M90.483 294.7H61.685V297.171H90.483V294.7Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M90.483 304.937H61.685V307.408H90.483V304.937Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M90.483 315.173H61.685V317.644H90.483V315.173Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M90.483 325.409H61.685V327.88H90.483V325.409Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M90.483 335.646H61.685V338.117H90.483V335.646Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M90.483 345.882H61.685V348.353H90.483V345.882Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M90.483 356.119H61.685V358.59H90.483V356.119Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M117.631 249.168H94.527V389.061H117.631V249.168Z",
    fill: "#DBDBDB"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M114.164 239.89H94.527V249.168H114.164V239.89Z",
    fill: "#A6A6A6"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M115.476 254.011H97.712V358.59H115.476V254.011Z",
    fill: "#C7C7C7"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M115.476 263.991H97.712V266.462H115.476V263.991Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M115.476 274.228H97.712V276.699H115.476V274.228Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M115.476 284.464H97.712V286.935H115.476V284.464Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M115.476 294.7H97.712V297.171H115.476V294.7Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M115.476 304.937H97.712V307.408H115.476V304.937Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M115.476 315.173H97.712V317.644H115.476V315.173Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M115.476 325.409H97.712V327.88H115.476V325.409Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M115.476 335.646H97.712V338.117H115.476V335.646Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M115.476 345.882H97.712V348.353H115.476V345.882Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M115.476 356.119H97.712V358.59H115.476V356.119Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M406.939 251.527H387.238V274.799H406.939V251.527Z",
    fill: "#DBDBDB"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M419.429 251.527H406.938V275.652H419.429V251.527Z",
    fill: "#C7C7C7"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M420.261 261.803H407.864V275.652H420.261V261.803Z",
    fill: "#DBDBDB"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M427.993 261.803H420.261V275.652H427.993V261.803Z",
    fill: "#C7C7C7"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M411.537 273.286H379.681V389.061H411.537V273.286Z",
    fill: "#EBEBEB"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M393.34 278.263H383.323V282.356H393.34V278.263Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M406.154 278.263H396.137V282.356H406.154V278.263Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M393.34 285.212H383.323V289.305H393.34V285.212Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M406.154 285.212H396.137V289.305H406.154V285.212Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M393.34 292.161H383.323V296.254H393.34V292.161Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M406.154 292.161H396.137V296.254H406.154V292.161Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M393.34 299.11H383.323V303.203H393.34V299.11Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M406.154 299.11H396.137V303.203H406.154V299.11Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M393.34 306.06H383.323V310.153H393.34V306.06Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M406.154 306.06H396.137V310.153H406.154V306.06Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M393.34 313.009H383.323V317.102H393.34V313.009Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M406.154 313.009H396.137V317.102H406.154V313.009Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M393.34 319.958H383.323V324.051H393.34V319.958Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M406.154 319.958H396.137V324.051H406.154V319.958Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M393.34 326.907H383.323V331H393.34V326.907Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M406.154 326.907H396.137V331H406.154V326.907Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M393.34 333.856H383.323V337.949H393.34V333.856Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M406.154 333.856H396.137V337.949H406.154V333.856Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M393.34 340.806H383.323V344.899H393.34V340.806Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M406.154 340.806H396.137V344.899H406.154V340.806Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M393.34 347.755H383.323V351.848H393.34V347.755Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M406.154 347.755H396.137V351.848H406.154V347.755Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M393.34 354.704H383.323V358.797H393.34V354.704Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M406.154 354.704H396.137V358.797H406.154V354.704Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M393.34 361.653H383.323V365.746H393.34V361.653Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M406.154 361.653H396.137V365.746H406.154V361.653Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M393.34 368.602H383.323V372.695H393.34V368.602Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M406.154 368.602H396.137V372.695H406.154V368.602Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M437.351 273.286H411.537V389.061H437.351V273.286Z",
    fill: "#C7C7C7"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M426.537 372.696H434.762V368.603H426.537V372.696Z",
    fill: "#EBEBEB"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M416.017 372.696H424.242V368.603H416.017V372.696Z",
    fill: "#EBEBEB"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M426.537 365.746H434.762V361.653H426.537V365.746Z",
    fill: "#EBEBEB"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M416.017 365.746H424.242V361.653H416.017V365.746Z",
    fill: "#EBEBEB"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M426.537 358.797H434.762V354.704H426.537V358.797Z",
    fill: "#EBEBEB"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M416.017 358.797H424.242V354.704H416.017V358.797Z",
    fill: "#EBEBEB"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M426.537 351.848H434.762V347.755H426.537V351.848Z",
    fill: "#EBEBEB"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M416.017 351.848H424.242V347.755H416.017V351.848Z",
    fill: "#EBEBEB"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M426.537 344.898H434.762V340.805H426.537V344.898Z",
    fill: "#EBEBEB"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M416.017 344.898H424.242V340.805H416.017V344.898Z",
    fill: "#EBEBEB"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M426.537 337.95H434.762V333.857H426.537V337.95Z",
    fill: "#EBEBEB"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M416.017 337.95H424.242V333.857H416.017V337.95Z",
    fill: "#EBEBEB"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M426.537 331H434.762V326.908H426.537V331Z",
    fill: "#EBEBEB"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M416.017 331H424.242V326.908H416.017V331Z",
    fill: "#EBEBEB"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M426.537 324.051H434.762V319.958H426.537V324.051Z",
    fill: "#EBEBEB"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M416.017 324.051H424.242V319.958H416.017V324.051Z",
    fill: "#EBEBEB"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M426.537 317.102H434.762V313.009H426.537V317.102Z",
    fill: "#EBEBEB"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M416.017 317.102H424.242V313.009H416.017V317.102Z",
    fill: "#EBEBEB"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M426.537 310.152H434.762V306.059H426.537V310.152Z",
    fill: "#EBEBEB"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M416.017 310.152H424.242V306.059H416.017V310.152Z",
    fill: "#EBEBEB"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M426.537 303.204H434.762V299.111H426.537V303.204Z",
    fill: "#EBEBEB"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M416.017 303.204H424.242V299.111H416.017V303.204Z",
    fill: "#EBEBEB"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M426.537 296.255H434.762V292.162H426.537V296.255Z",
    fill: "#EBEBEB"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M416.017 296.255H424.242V292.162H416.017V296.255Z",
    fill: "#EBEBEB"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M426.537 289.305H434.762V285.212H426.537V289.305Z",
    fill: "#EBEBEB"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M416.017 289.305H424.242V285.212H416.017V289.305Z",
    fill: "#EBEBEB"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M426.537 282.356H434.762V278.263H426.537V282.356Z",
    fill: "#EBEBEB"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M416.017 282.356H424.242V278.263H416.017V282.356Z",
    fill: "#EBEBEB"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M193.95 251.527H174.249V274.799H193.95V251.527Z",
    fill: "#DBDBDB"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M206.441 251.527H193.95V275.652H206.441V251.527Z",
    fill: "#C7C7C7"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M207.273 261.803H194.876V275.652H207.273V261.803Z",
    fill: "#DBDBDB"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M215.005 261.803H207.273V275.652H215.005V261.803Z",
    fill: "#C7C7C7"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M198.549 273.286H166.693V389.061H198.549V273.286Z",
    fill: "#EBEBEB"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M180.352 278.263H170.335V282.356H180.352V278.263Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M193.166 278.263H183.149V282.356H193.166V278.263Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M180.352 285.212H170.335V289.305H180.352V285.212Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M193.166 285.212H183.149V289.305H193.166V285.212Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M180.352 292.161H170.335V296.254H180.352V292.161Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M193.166 292.161H183.149V296.254H193.166V292.161Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M180.352 299.11H170.335V303.203H180.352V299.11Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M193.166 299.11H183.149V303.203H193.166V299.11Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M180.352 306.06H170.335V310.153H180.352V306.06Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M193.166 306.06H183.149V310.153H193.166V306.06Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M180.352 313.009H170.335V317.102H180.352V313.009Z",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M193.166 313.009H183.149V317.102H193.166V313.009Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M180.352 319.958H170.335V324.051H180.352V319.958Z",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M193.166 319.958H183.149V324.051H193.166V319.958Z",
    fill: "white"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M180.352 326.907H170.335V331H180.352V326.907Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M193.166 326.907H183.149V331H193.166V326.907Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M180.352 333.856H170.335V337.949H180.352V333.856Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M193.166 333.856H183.149V337.949H193.166V333.856Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M180.352 340.806H170.335V344.899H180.352V340.806Z",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M193.166 340.806H183.149V344.899H193.166V340.806Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M180.352 347.755H170.335V351.848H180.352V347.755Z",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M193.166 347.755H183.149V351.848H193.166V347.755Z",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M180.352 354.704H170.335V358.797H180.352V354.704Z",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M193.166 354.704H183.149V358.797H193.166V354.704Z",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M180.352 361.653H170.335V365.746H180.352V361.653Z",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M193.166 361.653H183.149V365.746H193.166V361.653Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M180.352 368.602H170.335V372.695H180.352V368.602Z",
    fill: "white"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M193.166 368.602H183.149V372.695H193.166V368.602Z",
    fill: "white"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M224.363 273.286H198.549V389.061H224.363V273.286Z",
    fill: "#C7C7C7"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M213.549 372.696H221.774V368.603H213.549V372.696Z",
    fill: "#EBEBEB"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M203.028 372.696H211.253V368.603H203.028V372.696Z",
    fill: "#EBEBEB"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M213.549 365.746H221.774V361.653H213.549V365.746Z",
    fill: "#EBEBEB"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M203.028 365.746H211.253V361.653H203.028V365.746Z",
    fill: "#EBEBEB"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M213.549 358.797H221.774V354.704H213.549V358.797Z",
    fill: "#EBEBEB"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M203.028 358.797H211.253V354.704H203.028V358.797Z",
    fill: "#EBEBEB"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M213.549 351.848H221.774V347.755H213.549V351.848Z",
    fill: "#EBEBEB"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M203.028 351.848H211.253V347.755H203.028V351.848Z",
    fill: "#EBEBEB"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M213.549 344.898H221.774V340.805H213.549V344.898Z",
    fill: "#EBEBEB"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M203.028 344.898H211.253V340.805H203.028V344.898Z",
    fill: "#EBEBEB"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M213.549 337.95H221.774V333.857H213.549V337.95Z",
    fill: "#EBEBEB"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M203.028 337.95H211.253V333.857H203.028V337.95Z",
    fill: "#EBEBEB"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M213.549 331H221.774V326.908H213.549V331Z",
    fill: "#EBEBEB"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M203.028 331H211.253V326.908H203.028V331Z",
    fill: "#EBEBEB"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M213.549 324.051H221.774V319.958H213.549V324.051Z",
    fill: "#EBEBEB"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M203.028 324.051H211.253V319.958H203.028V324.051Z",
    fill: "#EBEBEB"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M213.549 317.102H221.774V313.009H213.549V317.102Z",
    fill: "#EBEBEB"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M203.028 317.102H211.253V313.009H203.028V317.102Z",
    fill: "#EBEBEB"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M213.549 310.152H221.774V306.059H213.549V310.152Z",
    fill: "#EBEBEB"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M203.028 310.152H211.253V306.059H203.028V310.152Z",
    fill: "#EBEBEB"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M213.549 303.204H221.774V299.111H213.549V303.204Z",
    fill: "#EBEBEB"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M203.028 303.204H211.253V299.111H203.028V303.204Z",
    fill: "#EBEBEB"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M213.549 296.255H221.774V292.162H213.549V296.255Z",
    fill: "#EBEBEB"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M203.028 296.255H211.253V292.162H203.028V296.255Z",
    fill: "#EBEBEB"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M213.549 289.305H221.774V285.212H213.549V289.305Z",
    fill: "#EBEBEB"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M203.028 289.305H211.253V285.212H203.028V289.305Z",
    fill: "#EBEBEB"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M213.549 282.356H221.774V278.263H213.549V282.356Z",
    fill: "#EBEBEB"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M203.028 282.356H211.253V278.263H203.028V282.356Z",
    fill: "#EBEBEB"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M250 456.766C345.088 456.766 422.172 449.063 422.172 439.562C422.172 430.06 345.088 422.358 250 422.358C154.912 422.358 77.828 430.06 77.828 439.562C77.828 449.063 154.912 456.766 250 456.766Z",
    fill: "#EBEBEB"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M347.124 313.621H309.55V389.062H347.124V313.621Z",
    fill: "#37474F"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M322.108 320.151H315.459V324.773H322.108V320.151Z",
    fill: "#455A64"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M322.108 330.023H315.459V334.645H322.108V330.023Z",
    fill: "#455A64"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M322.108 339.895H315.459V344.517H322.108V339.895Z",
    fill: "#455A64"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M322.108 349.767H315.459V354.389H322.108V349.767Z",
    fill: "#455A64"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M322.108 359.639H315.459V364.261H322.108V359.639Z",
    fill: "#455A64"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M322.108 369.511H315.459V374.133H322.108V369.511Z",
    fill: "#455A64"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M322.108 379.384H315.459V384.006H322.108V379.384Z",
    fill: "#455A64"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M331.673 320.151H325.024V324.773H331.673V320.151Z",
    fill: "#455A64"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M331.673 330.023H325.024V334.645H331.673V330.023Z",
    fill: "#455A64"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M331.673 339.895H325.024V344.517H331.673V339.895Z",
    fill: "#455A64"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M331.673 349.767H325.024V354.389H331.673V349.767Z",
    fill: "#455A64"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M331.673 359.639H325.024V364.261H331.673V359.639Z",
    fill: "#455A64"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M331.673 369.511H325.024V374.133H331.673V369.511Z",
    fill: "#455A64"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M331.673 379.384H325.024V384.006H331.673V379.384Z",
    fill: "#455A64"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M341.215 320.151H334.566V324.773H341.215V320.151Z",
    fill: "#455A64"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M341.215 330.023H334.566V334.645H341.215V330.023Z",
    fill: "#455A64"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M341.215 339.895H334.566V344.517H341.215V339.895Z",
    fill: "#455A64"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M341.215 349.767H334.566V354.389H341.215V349.767Z",
    fill: "#455A64"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M341.215 359.639H334.566V364.261H341.215V359.639Z",
    fill: "#455A64"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M341.215 369.511H334.566V374.133H341.215V369.511Z",
    fill: "#455A64"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M341.215 379.384H334.566V384.006H341.215V379.384Z",
    fill: "#455A64"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M347.125 305.76H322.109V313.62H347.125V305.76Z",
    fill: "#455A64"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M347.124 300.894H331.265V305.76H347.124V300.894Z",
    fill: "#37474F"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M373.486 313.621H347.124V389.062H373.486V313.621Z",
    fill: "#263238"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M365.376 383.269H370.789V378.647H365.376V383.269Z",
    fill: "#37474F"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M365.376 373.397H370.789V368.775H365.376V373.397Z",
    fill: "#37474F"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M365.376 363.524H370.789V358.902H365.376V363.524Z",
    fill: "#37474F"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M365.376 353.652H370.789V349.03H365.376V353.652Z",
    fill: "#37474F"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M365.376 343.78H370.789V339.158H365.376V343.78Z",
    fill: "#37474F"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M365.376 333.907H370.789V329.285H365.376V333.907Z",
    fill: "#37474F"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M365.376 324.036H370.789V319.414H365.376V324.036Z",
    fill: "#37474F"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M357.589 383.269H363.002V378.647H357.589V383.269Z",
    fill: "#37474F"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M357.589 373.397H363.002V368.775H357.589V373.397Z",
    fill: "#37474F"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M357.589 363.524H363.002V358.902H357.589V363.524Z",
    fill: "#37474F"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M357.589 353.652H363.002V349.03H357.589V353.652Z",
    fill: "#37474F"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M357.589 343.78H363.002V339.158H357.589V343.78Z",
    fill: "#37474F"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M357.589 333.907H363.002V329.285H357.589V333.907Z",
    fill: "#37474F"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M357.589 324.036H363.002V319.414H357.589V324.036Z",
    fill: "#37474F"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M349.823 383.269H355.236V378.647H349.823V383.269Z",
    fill: "#37474F"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M349.823 373.397H355.236V368.775H349.823V373.397Z",
    fill: "#37474F"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M349.823 363.524H355.236V358.902H349.823V363.524Z",
    fill: "#37474F"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M349.823 353.652H355.236V349.03H349.823V353.652Z",
    fill: "#37474F"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M349.823 343.78H355.236V339.158H349.823V343.78Z",
    fill: "#37474F"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M349.823 333.907H355.236V329.285H349.823V333.907Z",
    fill: "#37474F"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M349.823 324.036H355.236V319.414H349.823V324.036Z",
    fill: "#37474F"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M369.493 305.76H347.124V313.62H369.493V305.76Z",
    fill: "#37474F"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M359.245 300.894H347.124V305.76H359.245V300.894Z",
    fill: "#263238"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M336.9 97.4639H347.039C324.807 97.4639 306.799 115.751 306.799 138.315C306.799 160.89 324.808 179.176 347.039 179.176H336.9C314.668 179.176 296.66 160.89 296.66 138.315C296.66 115.75 314.668 97.4639 336.9 97.4639Z",
    fill: "#073C7C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.9 97.4639H347.039C324.807 97.4639 306.799 115.751 306.799 138.315C306.799 160.89 324.808 179.176 347.039 179.176H336.9C314.668 179.176 296.66 160.89 296.66 138.315C296.66 115.75 314.668 97.4639 336.9 97.4639Z",
    fill: "black"
  }))), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M347.036 295.113H336.9C377.747 247.517 416.013 195.354 410.385 137.75C406.73 100.441 381.402 63.2839 336.9 63.2839H347.036C391.538 63.2839 416.866 100.441 420.521 137.75C426.149 195.354 387.895 247.517 347.036 295.113Z",
    fill: "#073C7C"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.036 295.113H336.9C377.747 247.517 416.013 195.354 410.385 137.75C406.73 100.441 381.402 63.2839 336.9 63.2839H347.036C391.538 63.2839 416.866 100.441 420.521 137.75C426.149 195.354 387.895 247.517 347.036 295.113Z",
    fill: "black"
  }))), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M410.384 137.747C416.014 195.35 377.751 247.519 336.9 295.117C296.101 247.519 257.837 195.35 263.457 137.747C267.121 100.438 292.437 63.2869 336.9 63.2869C381.405 63.2869 406.731 100.438 410.384 137.747ZM336.9 179.175C359.183 179.175 377.192 160.889 377.192 138.314C377.192 115.75 359.183 97.4629 336.9 97.4629C314.668 97.4629 296.66 115.75 296.66 138.314C296.66 160.889 314.668 179.175 336.9 179.175Z",
    fill: "#073C7C"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M50.88 393.704L100.66 393.461L150.44 393.373L250 393.205L349.56 393.372L399.34 393.459L449.12 393.704L399.34 393.949L349.56 394.036L250 394.203L150.44 394.035L100.66 393.947L50.88 393.704Z",
    fill: "#263238"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M449.298 389.061H50.701V393.704H449.298V389.061Z",
    fill: "#C7C7C7"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M62.225 389.061C62.383 389.835 62.419 390.609 62.426 391.382C62.42 392.156 62.384 392.93 62.225 393.703C62.066 392.929 62.03 392.155 62.024 391.382C62.031 390.609 62.067 389.835 62.225 389.061Z",
    fill: "#263238"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M75.638 389.061C75.796 389.835 75.832 390.609 75.839 391.382C75.833 392.156 75.798 392.93 75.638 393.703C75.479 392.929 75.443 392.155 75.437 391.382C75.444 390.609 75.479 389.835 75.638 389.061Z",
    fill: "#263238"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M89.05 389.061C89.208 389.835 89.244 390.609 89.251 391.382C89.245 392.156 89.21 392.93 89.05 393.703C88.891 392.929 88.855 392.155 88.849 391.382C88.856 390.609 88.892 389.835 89.05 389.061Z",
    fill: "#263238"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M102.463 389.061C102.621 389.835 102.657 390.609 102.664 391.382C102.658 392.156 102.623 392.93 102.463 393.703C102.304 392.929 102.268 392.155 102.262 391.382C102.269 390.609 102.304 389.835 102.463 389.061Z",
    fill: "#263238"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M115.875 389.061C116.033 389.835 116.069 390.609 116.076 391.382C116.07 392.156 116.035 392.93 115.875 393.703C115.716 392.929 115.68 392.155 115.674 391.382C115.681 390.609 115.717 389.835 115.875 389.061Z",
    fill: "#263238"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M129.288 389.061C129.446 389.835 129.482 390.609 129.489 391.382C129.483 392.156 129.448 392.93 129.288 393.703C129.129 392.929 129.093 392.155 129.087 391.382C129.094 390.609 129.129 389.835 129.288 389.061Z",
    fill: "#263238"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M142.7 389.061C142.858 389.835 142.894 390.609 142.901 391.382C142.895 392.156 142.86 392.93 142.7 393.703C142.541 392.929 142.505 392.155 142.499 391.382C142.506 390.609 142.542 389.835 142.7 389.061Z",
    fill: "#263238"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M156.113 389.061C156.271 389.835 156.307 390.609 156.314 391.382C156.308 392.156 156.272 392.93 156.113 393.703C155.954 392.929 155.918 392.155 155.912 391.382C155.919 390.609 155.954 389.835 156.113 389.061Z",
    fill: "#263238"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M169.525 389.061C169.683 389.835 169.719 390.609 169.726 391.382C169.72 392.156 169.684 392.93 169.525 393.703C169.366 392.929 169.33 392.155 169.324 391.382C169.331 390.609 169.367 389.835 169.525 389.061Z",
    fill: "#263238"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M182.938 389.061C183.096 389.835 183.132 390.609 183.139 391.382C183.133 392.156 183.097 392.93 182.938 393.703C182.779 392.929 182.743 392.155 182.737 391.382C182.744 390.609 182.779 389.835 182.938 389.061Z",
    fill: "#263238"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M196.35 389.061C196.508 389.835 196.544 390.609 196.551 391.382C196.545 392.156 196.51 392.93 196.35 393.703C196.191 392.929 196.155 392.155 196.149 391.382C196.156 390.609 196.192 389.835 196.35 389.061Z",
    fill: "#263238"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M209.762 389.061C209.92 389.835 209.956 390.609 209.963 391.382C209.957 392.156 209.922 392.93 209.762 393.703C209.603 392.929 209.567 392.155 209.561 391.382C209.569 390.609 209.604 389.835 209.762 389.061Z",
    fill: "#263238"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M223.175 389.061C223.333 389.835 223.369 390.609 223.376 391.382C223.37 392.156 223.335 392.93 223.175 393.703C223.016 392.929 222.98 392.155 222.974 391.382C222.981 390.609 223.017 389.835 223.175 389.061Z",
    fill: "#263238"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M236.587 389.061C236.745 389.835 236.781 390.609 236.788 391.382C236.782 392.156 236.747 392.93 236.587 393.703C236.428 392.929 236.392 392.155 236.386 391.382C236.394 390.609 236.429 389.835 236.587 389.061Z",
    fill: "#263238"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M250 389.061C250.158 389.835 250.194 390.609 250.201 391.382C250.195 392.156 250.16 392.93 250 393.703C249.841 392.929 249.805 392.155 249.799 391.382C249.806 390.609 249.842 389.835 250 389.061Z",
    fill: "#263238"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M263.412 389.061C263.57 389.835 263.606 390.609 263.613 391.382C263.607 392.156 263.571 392.93 263.412 393.703C263.253 392.929 263.217 392.155 263.211 391.382C263.218 390.609 263.254 389.835 263.412 389.061Z",
    fill: "#263238"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M276.825 389.061C276.983 389.835 277.019 390.609 277.026 391.382C277.02 392.156 276.984 392.93 276.825 393.703C276.666 392.929 276.63 392.155 276.624 391.382C276.631 390.609 276.667 389.835 276.825 389.061Z",
    fill: "#263238"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M290.237 389.061C290.395 389.835 290.431 390.609 290.438 391.382C290.432 392.156 290.396 392.93 290.237 393.703C290.078 392.929 290.042 392.155 290.036 391.382C290.043 390.609 290.079 389.835 290.237 389.061Z",
    fill: "#263238"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M303.65 389.061C303.808 389.835 303.844 390.609 303.851 391.382C303.845 392.156 303.81 392.93 303.65 393.703C303.491 392.929 303.455 392.155 303.449 391.382C303.456 390.609 303.492 389.835 303.65 389.061Z",
    fill: "#263238"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M317.062 389.061C317.22 389.835 317.256 390.609 317.263 391.382C317.257 392.156 317.222 392.93 317.062 393.703C316.903 392.929 316.867 392.155 316.861 391.382C316.868 390.609 316.904 389.835 317.062 389.061Z",
    fill: "#263238"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M330.475 389.061C330.633 389.835 330.669 390.609 330.676 391.382C330.67 392.156 330.635 392.93 330.475 393.703C330.316 392.929 330.28 392.155 330.274 391.382C330.281 390.609 330.317 389.835 330.475 389.061Z",
    fill: "#263238"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M343.887 389.061C344.045 389.835 344.081 390.609 344.088 391.382C344.082 392.156 344.047 392.93 343.887 393.703C343.728 392.929 343.692 392.155 343.686 391.382C343.693 390.609 343.729 389.835 343.887 389.061Z",
    fill: "#263238"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M357.3 389.061C357.458 389.835 357.494 390.609 357.501 391.382C357.495 392.156 357.46 392.93 357.3 393.703C357.141 392.929 357.105 392.155 357.099 391.382C357.106 390.609 357.141 389.835 357.3 389.061Z",
    fill: "#263238"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M370.712 389.061C370.87 389.835 370.906 390.609 370.913 391.382C370.907 392.156 370.871 392.93 370.712 393.703C370.553 392.929 370.517 392.155 370.511 391.382C370.518 390.609 370.554 389.835 370.712 389.061Z",
    fill: "#263238"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M384.125 389.061C384.283 389.835 384.319 390.609 384.326 391.382C384.32 392.156 384.284 392.93 384.125 393.703C383.966 392.929 383.93 392.155 383.924 391.382C383.931 390.609 383.966 389.835 384.125 389.061Z",
    fill: "#263238"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M397.537 389.061C397.695 389.835 397.731 390.609 397.738 391.382C397.732 392.156 397.696 392.93 397.537 393.703C397.378 392.929 397.342 392.155 397.336 391.382C397.343 390.609 397.379 389.835 397.537 389.061Z",
    fill: "#263238"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M410.95 389.061C411.108 389.835 411.144 390.609 411.151 391.382C411.145 392.156 411.11 392.93 410.95 393.703C410.791 392.929 410.755 392.155 410.749 391.382C410.756 390.609 410.791 389.835 410.95 389.061Z",
    fill: "#263238"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M424.362 389.061C424.52 389.835 424.556 390.609 424.563 391.382C424.557 392.156 424.522 392.93 424.362 393.703C424.203 392.929 424.167 392.155 424.161 391.382C424.168 390.609 424.204 389.835 424.362 389.061Z",
    fill: "#263238"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M437.775 389.061C437.933 389.835 437.969 390.609 437.976 391.382C437.97 392.156 437.935 392.93 437.775 393.703C437.616 392.929 437.58 392.155 437.574 391.382C437.581 390.609 437.616 389.835 437.775 389.061Z",
    fill: "#263238"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M92.452 389.061H70.469C70.469 389.061 70.52 385.789 72.681 384.921C74.842 384.053 76.127 385.747 76.127 385.747C76.127 385.747 77.009 379.731 81.036 379.731C85.063 379.731 86.991 384.921 86.991 384.921C86.991 384.921 87.893 383.352 90.129 383.644C92.363 383.936 92.452 389.061 92.452 389.061Z",
    fill: "#37474F"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M445.862 389.061C445.862 389.061 445.188 385.917 443.842 385.432C442.496 384.948 441.677 386.359 441.677 386.359C441.677 386.359 441.36 383.355 439.452 382.455C437.544 381.556 436.111 383.397 436.111 383.397C436.111 383.397 434.647 379.584 432.03 379.584C429.414 379.584 428.094 385.162 428.094 385.162C428.094 385.162 426.551 383.5 424.968 384.438C423.385 385.377 423.385 389.059 423.385 389.059H445.862V389.061Z",
    fill: "#37474F"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M240.589 389.061C240.589 389.061 239.915 385.917 238.569 385.432C237.223 384.948 236.404 386.359 236.404 386.359C236.404 386.359 236.087 383.355 234.179 382.455C232.271 381.556 230.838 383.397 230.838 383.397C230.838 383.397 229.374 379.584 226.757 379.584C224.14 379.584 222.821 385.162 222.821 385.162C222.821 385.162 221.277 383.5 219.695 384.438C218.112 385.377 218.112 389.059 218.112 389.059H240.589V389.061Z",
    fill: "#37474F"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M74.409 389.061H54.138C54.138 389.061 54.806 386.203 56.15 386.001C57.494 385.799 58.119 387.124 58.119 387.124C58.119 387.124 58.058 383.138 60.569 382.459C63.079 381.78 65.185 385.302 65.185 385.302C65.185 385.302 66.759 383.294 68.904 383.423C71.049 383.552 71.594 386.869 71.594 386.869C71.594 386.869 73.546 385.717 74.409 389.061Z",
    fill: "#455A64"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M222.483 389.061H202.212C202.212 389.061 202.88 386.203 204.224 386.001C205.568 385.799 206.193 387.124 206.193 387.124C206.193 387.124 206.132 383.138 208.643 382.459C211.153 381.78 213.259 385.302 213.259 385.302C213.259 385.302 214.833 383.294 216.978 383.423C219.123 383.552 219.668 386.869 219.668 386.869C219.668 386.869 221.62 385.717 222.483 389.061Z",
    fill: "#455A64"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M424.838 389.061H412.384C412.384 389.061 412.413 387.207 413.637 386.716C414.861 386.224 415.589 387.184 415.589 387.184C415.589 387.184 416.088 383.776 418.37 383.776C420.652 383.776 421.744 386.716 421.744 386.716C421.744 386.716 422.255 385.827 423.522 385.993C424.788 386.158 424.838 389.061 424.838 389.061Z",
    fill: "#455A64"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M272.466 389.061H260.012C260.012 389.061 260.041 387.207 261.265 386.716C262.489 386.224 263.217 387.184 263.217 387.184C263.217 387.184 263.716 383.776 265.998 383.776C268.28 383.776 269.372 386.716 269.372 386.716C269.372 386.716 269.883 385.827 271.15 385.993C272.415 386.158 272.466 389.061 272.466 389.061Z",
    fill: "#455A64"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M220.861 442.906C218.529 443.659 152.039 442.812 149.53 441.17C148.566 440.563 148.124 430.867 147.927 419.137C147.926 419.014 147.925 418.892 147.924 418.769C147.878 416.352 147.846 413.862 147.842 411.339C147.841 410.992 147.84 410.644 147.829 410.298L151.048 375.804L195.526 376.239L191.144 410.41L191.093 411.763L190.826 418.836L190.8 419.564C190.8 419.564 216.105 431.272 218.676 433.367C221.227 435.457 223.195 442.164 220.861 442.906Z",
    fill: "#DD6A57"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M220.861 442.906C218.529 443.659 152.039 442.812 149.53 441.17C148.566 440.563 148.124 430.867 147.927 419.137C147.926 419.014 147.925 418.892 147.924 418.769C147.878 416.352 147.846 413.862 147.842 411.339C147.841 410.992 147.84 410.644 147.829 410.298L191.144 410.41L191.093 411.763L190.826 418.836L190.8 419.564C190.8 419.564 216.105 431.272 218.676 433.367C221.227 435.457 223.195 442.164 220.861 442.906Z",
    fill: "#EBEBEB"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M220.868 442.902C219.668 443.289 201.604 443.252 183.946 442.9C180.396 442.83 176.867 442.749 173.5 442.658C160.908 442.315 150.503 441.799 149.536 441.168C148.58 440.568 148.14 431.14 147.945 419.626C147.945 419.463 147.935 419.3 147.935 419.138C147.935 419.016 147.935 418.884 147.925 418.762H147.976L190.827 418.834L190.807 419.566C190.807 419.566 216.116 431.267 218.679 433.362C221.232 435.457 223.197 442.159 220.868 442.902Z",
    fill: "#FFC727"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M220.142 440.319C208.937 439.901 163.706 439.272 152.598 439.711C152.508 439.715 152.507 439.776 152.597 439.782C163.694 440.439 208.929 440.701 220.139 440.504C220.376 440.498 220.378 440.328 220.142 440.319Z",
    fill: "#263238"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M195.601 419.021C191.201 418.142 185.798 418.75 182.388 421.849C182.256 421.969 182.428 422.155 182.572 422.112C186.941 420.796 191.015 419.967 195.577 419.578C195.898 419.551 195.916 419.084 195.601 419.021Z",
    fill: "#263238"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M198.76 420.98C194.36 420.101 188.957 420.709 185.547 423.808C185.415 423.928 185.588 424.114 185.731 424.071C190.1 422.755 194.175 421.926 198.736 421.537C199.057 421.51 199.075 421.043 198.76 420.98Z",
    fill: "#263238"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M201.919 422.94C197.519 422.06 192.116 422.669 188.706 425.768C188.574 425.888 188.746 426.074 188.89 426.031C193.259 424.715 197.334 423.886 201.895 423.497C202.216 423.469 202.234 423.002 201.919 422.94Z",
    fill: "#263238"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M183.946 442.9C180.396 442.83 176.867 442.749 173.5 442.658C160.908 442.315 150.503 441.799 149.536 441.168C148.58 440.568 148.14 431.14 147.945 419.626C147.945 419.463 147.935 419.3 147.935 419.138C147.935 419.016 147.935 418.884 147.925 418.762H147.976C153.845 422.88 174.536 436.647 183.946 442.9Z",
    fill: "#263238"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M193.388 418.985L145.502 418.996C145.502 418.996 155.119 307.151 154.742 305.199C154.263 302.697 151.433 291.377 147.667 276.589C146.486 271.961 145.213 266.998 143.89 261.852C140.317 247.939 136.377 232.734 132.947 219.502C127.796 199.68 123.775 184.281 123.775 184.281L164.358 184.272C164.358 184.272 169.091 199.263 175.056 218.771C184.777 250.472 197.765 294.104 199.049 304.712C201.127 321.839 193.388 418.985 193.388 418.985Z",
    fill: "#455A64"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M191.265 410.816C183.952 410.665 186.053 410.606 178.738 410.537C175.158 410.503 151.637 410.304 148.293 410.858C148.219 410.87 148.219 410.995 148.293 411.007C151.637 411.56 175.158 411.35 178.738 411.315C186.052 411.243 183.952 411.184 191.264 411.03C191.403 411.026 191.403 410.819 191.265 410.816Z",
    fill: "#263238"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M163.751 298.361C162.179 291.439 159.832 284.656 157.788 277.862C153.634 264.057 149.447 250.262 145.252 236.47C143.155 229.574 141.053 222.679 138.931 215.79C137.859 212.312 136.789 208.832 135.699 205.36C134.632 201.962 133.419 198.592 132.457 195.163C132.066 193.768 131.852 194.535 132.353 196.306C133.364 199.877 134.362 203.453 135.404 207.015C137.468 214.07 139.549 221.121 141.636 228.169C145.79 242.197 150.001 256.209 154.207 270.222C156.316 277.247 158.439 284.269 160.551 291.294C161.56 294.651 162.548 298.027 163.142 301.487C163.761 305.096 163.795 308.746 163.567 312.393C163.109 319.719 162.262 327.035 161.588 334.345C160.912 341.67 160.235 348.995 159.559 356.319C158.213 370.896 156.866 385.473 155.557 400.053C155.391 401.901 155.23 403.749 155.088 405.599C155.04 406.218 155.976 406.171 156.041 405.575C157.615 391.161 158.821 376.7 160.171 362.263C161.515 347.898 162.858 333.532 164.197 319.167C164.533 315.56 164.916 311.947 164.918 308.321C164.921 304.957 164.496 301.639 163.751 298.361Z",
    fill: "#263238"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M159.75 184.272C156.938 206.07 151.576 246.939 147.667 276.589C138.505 240.666 123.774 184.28 123.774 184.28L159.75 184.272Z",
    fill: "#263238"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M169.268 443.559C166.938 444.321 100.446 443.716 97.931 442.084C96.964 441.48 96.488 431.786 96.248 420.057C96.247 419.935 96.245 419.812 96.244 419.69C96.189 417.273 96.148 414.784 96.135 412.261C96.133 411.913 96.131 411.566 96.118 411.22C95.959 394.292 97.176 376.726 97.176 376.726L140.638 376.999L139.432 411.173L139.386 412.526L139.145 419.6L139.122 420.328C139.122 420.328 164.47 431.943 167.048 434.03C169.606 436.107 171.598 442.807 169.268 443.559Z",
    fill: "#DD6A57"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M169.268 443.559C166.938 444.321 100.446 443.716 97.931 442.084C96.964 441.48 96.488 431.786 96.248 420.057C96.247 419.935 96.245 419.812 96.244 419.69C96.189 417.273 96.148 414.784 96.135 412.261C96.133 411.913 96.131 411.566 96.118 411.22L139.433 411.174L139.387 412.527L139.146 419.601L139.123 420.329C139.123 420.329 164.471 431.944 167.049 434.031C169.606 436.107 171.598 442.807 169.268 443.559Z",
    fill: "#EBEBEB"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M169.268 443.559C166.938 444.321 100.446 443.716 97.931 442.084C96.964 441.48 96.488 431.786 96.248 420.057C96.247 419.935 96.245 419.812 96.244 419.69L139.146 419.601L139.123 420.329C139.123 420.329 164.471 431.944 167.049 434.031C169.606 436.107 171.598 442.807 169.268 443.559Z",
    fill: "#FFC727"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M168.538 440.973C157.332 440.596 112.099 440.132 100.993 440.611C100.903 440.615 100.902 440.676 100.992 440.681C112.091 441.297 157.327 441.394 168.537 441.156C168.774 441.152 168.775 440.982 168.538 440.973Z",
    fill: "#263238"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M143.92 419.765C139.517 418.902 134.116 419.53 130.717 422.642C130.585 422.762 130.759 422.948 130.902 422.904C135.266 421.572 139.338 420.728 143.897 420.322C144.219 420.294 144.235 419.827 143.92 419.765Z",
    fill: "#263238"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M147.086 421.713C142.683 420.85 137.282 421.478 133.883 424.589C133.751 424.71 133.925 424.895 134.068 424.851C138.432 423.519 142.504 422.675 147.063 422.269C147.385 422.242 147.402 421.775 147.086 421.713Z",
    fill: "#263238"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M150.252 423.661C145.849 422.798 140.448 423.426 137.049 426.538C136.917 426.658 137.091 426.844 137.234 426.8C141.598 425.468 145.67 424.624 150.229 424.218C150.551 424.189 150.568 423.723 150.252 423.661Z",
    fill: "#263238"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M163.046 184.271C163.046 184.271 162.114 203.688 157.673 219.068C157.317 220.339 156.931 221.59 156.514 222.791C156.514 222.791 151.887 224.47 144.819 228.805C144.819 228.805 144.355 244.428 143.891 261.852C143.377 281.33 142.843 303.056 142.956 307.663C143.367 324.903 140.825 419.699 140.825 419.699L92.949 419.903C92.949 419.903 101.581 314.039 101.519 307.723C101.425 297.572 103.826 252.706 105.68 219.985C106.815 199.825 107.747 184.284 107.747 184.284L163.046 184.271Z",
    fill: "#455A64"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M139.181 411.183C131.867 411.063 133.968 410.995 126.653 410.957C123.073 410.938 99.551 410.839 96.21 411.408C96.136 411.421 96.137 411.545 96.21 411.557C99.557 412.096 123.077 411.786 126.656 411.735C133.97 411.632 131.869 411.582 139.181 411.397C139.319 411.393 139.319 411.185 139.181 411.183Z",
    fill: "#263238"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M111.77 191.221C110.895 217.932 109.967 244.645 108.778 271.344C107.585 298.135 105.976 324.916 103.741 351.641C102.492 366.572 101.316 387.575 99.708 402.472C99.697 402.572 99.85 402.608 99.863 402.506C103.343 376.009 105.279 343.246 106.987 316.582C108.695 289.922 109.851 263.216 110.754 236.518C111.265 221.415 111.654 206.308 112.103 191.204C112.109 190.988 111.777 191.008 111.77 191.221Z",
    fill: "#263238"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M158.504 221.634C153.738 223.528 149.173 226.115 144.819 228.806C144.648 228.911 144.776 229.178 144.963 229.088C149.581 226.843 154.296 224.681 158.785 222.185C159.137 221.989 158.87 221.489 158.504 221.634Z",
    fill: "#263238"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M158.769 205.16C158.453 206.862 158.041 208.546 157.674 210.238C157.33 211.825 157.076 213.444 156.657 215.013C156.25 216.535 155.603 217.929 154.434 219.016C153.811 219.595 153.126 220.107 152.462 220.637C152.104 220.923 151.718 221.197 151.346 221.487C151.394 221.262 151.433 221.034 151.474 220.802C151.587 220.157 151.696 219.511 151.804 218.865C152.044 217.432 152.273 215.996 152.493 214.56C152.924 211.736 153.321 208.883 153.909 206.087C153.933 205.973 153.762 205.93 153.733 206.043C153.03 208.813 152.254 211.554 151.642 214.347C151.342 215.717 150.271 222.482 150.224 222.961C150.175 223.455 150.134 223.951 150.116 224.448C150.099 224.938 150.002 225.486 150.115 225.967C150.144 226.09 150.293 226.07 150.345 225.987C150.347 225.989 150.35 225.99 150.352 225.992C150.598 225.561 150.659 224.998 150.782 224.522C150.906 224.039 151.015 223.549 151.102 223.059C151.133 222.882 151.158 222.701 151.183 222.52C151.849 222.115 152.469 221.579 153.092 221.128C153.763 220.642 154.447 220.168 155.082 219.633C156.298 218.609 157.058 217.354 157.511 215.837C157.981 214.263 158.125 212.601 158.307 210.976C158.521 209.054 158.678 207.121 158.946 205.206C158.961 205.091 158.791 205.044 158.769 205.16Z",
    fill: "#263238"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M145.805 134.185C148.459 141.585 157.816 158.185 172.154 171.262C177.695 176.307 218.985 172.995 223.078 171.399C225.941 170.282 231.276 149.466 228.27 147.588C222.632 144.065 185.717 152.196 184.147 151.367C181.75 150.09 165.855 139.437 155.619 129.316C148.151 121.941 141.404 121.868 145.805 134.185Z",
    fill: "#DD6A57"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M156.416 156.065L179.842 146.759C179.842 146.759 158.822 128.687 151.14 125.117C142.495 121.099 142.331 126.398 145.368 134.936C148.406 143.473 156.416 156.065 156.416 156.065Z",
    fill: "#073C7C"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M174.895 143.909C174.035 144.105 166.689 146.891 165.105 147.531C163.521 148.171 157.023 150.724 155.443 151.522C155.373 151.557 155.406 151.662 155.484 151.64C157.177 151.156 163.739 148.599 165.365 147.981C166.991 147.363 174.199 144.445 174.947 144.015C175.01 143.977 174.953 143.895 174.895 143.909Z",
    fill: "#263238"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M165.45 152.47L156.42 156.06C156.42 156.06 148.41 143.47 145.37 134.94C143.15 128.7 142.64 124.18 145.9 123.78L165.45 152.47Z",
    fill: "#003371"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M102.396 205.41C102.549 205.583 168.784 206.013 169.39 205.335C170.236 204.38 155.529 132.568 148.762 123.678C147.313 121.777 138.182 119.189 132.878 123.508C121.621 132.675 111.845 164.154 109.582 173.654C105.831 189.306 101.852 204.786 102.396 205.41Z",
    fill: "#FFC727"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M149.137 124.239H132.037C132.317 123.979 132.597 123.739 132.877 123.509C133.047 123.369 133.227 123.239 133.407 123.119H148.137C148.407 123.309 148.617 123.499 148.757 123.679C148.887 123.839 149.007 124.029 149.137 124.239Z",
    fill: "black"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M150.737 127.459H129.087C129.397 127.069 129.707 126.689 130.027 126.329H150.247C150.407 126.679 150.567 127.059 150.737 127.459Z",
    fill: "black"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M151.977 130.679H126.767C127.027 130.289 127.277 129.919 127.537 129.549H151.567C151.697 129.909 151.837 130.289 151.977 130.679Z",
    fill: "black"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M153.067 133.889H124.797C125.017 133.509 125.237 133.129 125.467 132.759H152.697C152.827 133.129 152.947 133.509 153.067 133.889Z",
    fill: "black"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M154.087 137.109H123.037C123.237 136.729 123.427 136.349 123.637 135.979H153.737C153.847 136.349 153.967 136.729 154.087 137.109Z",
    fill: "black"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M155.037 140.329H121.427C121.607 139.949 121.787 139.569 121.977 139.199H154.707C154.817 139.569 154.927 139.949 155.037 140.329Z",
    fill: "black"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M155.947 143.539H119.947C120.117 143.159 120.287 142.789 120.457 142.409H155.627C155.737 142.779 155.837 143.159 155.947 143.539Z",
    fill: "black"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M156.817 146.759H118.557C118.717 146.379 118.877 145.999 119.037 145.629H156.517C156.617 145.999 156.717 146.379 156.817 146.759Z",
    fill: "black"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M157.667 149.979H117.257C117.397 149.599 117.547 149.229 117.707 148.849H157.377C157.467 149.219 157.567 149.599 157.667 149.979Z",
    fill: "black"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M158.487 153.189H116.017C116.157 152.809 116.297 152.439 116.447 152.059H158.207C158.297 152.439 158.397 152.809 158.487 153.189Z",
    fill: "black"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M159.297 156.409H114.847C114.977 156.029 115.117 155.659 115.257 155.279H159.017C159.107 155.659 159.197 156.029 159.297 156.409Z",
    fill: "black"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M160.077 159.619H113.737C113.857 159.249 113.987 158.869 114.127 158.499H159.807C159.897 158.869 159.987 159.249 160.077 159.619Z",
    fill: "black"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M160.847 162.839H112.677C112.797 162.469 112.917 162.089 113.037 161.709H160.577C160.667 162.089 160.757 162.459 160.847 162.839Z",
    fill: "black"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M161.597 166.059H111.677C111.787 165.689 111.897 165.309 112.017 164.929H161.347C161.427 165.309 161.517 165.689 161.597 166.059Z",
    fill: "black"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M162.347 169.269H110.737C110.837 168.909 110.947 168.539 111.057 168.149H162.087C162.167 168.529 162.257 168.899 162.347 169.269Z",
    fill: "black"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M163.067 172.489H109.867C109.957 172.139 110.057 171.759 110.157 171.359H162.817C162.897 171.739 162.987 172.109 163.067 172.489Z",
    fill: "black"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M163.787 175.709H109.087C109.177 175.339 109.267 174.959 109.357 174.579H163.537C163.617 174.959 163.697 175.339 163.787 175.709Z",
    fill: "black"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M164.487 178.919H108.307C108.397 178.549 108.487 178.179 108.577 177.799H164.247C164.327 178.169 164.407 178.549 164.487 178.919Z",
    fill: "black"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M165.167 182.139H107.527C107.617 181.759 107.707 181.389 107.797 181.009H164.927C165.017 181.389 165.097 181.759 165.167 182.139Z",
    fill: "black"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M165.847 185.359H106.747C106.837 184.989 106.927 184.609 107.017 184.229H165.617C165.697 184.609 165.777 184.989 165.847 185.359Z",
    fill: "black"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M166.507 188.569H105.967C106.057 188.199 106.147 187.819 106.237 187.439H166.277C166.357 187.819 166.437 188.199 166.507 188.569Z",
    fill: "black"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M167.157 191.789H105.177C105.277 191.419 105.367 191.039 105.457 190.659H166.927C167.007 191.039 167.087 191.419 167.157 191.789Z",
    fill: "black"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M167.787 195.009H104.417C104.507 194.639 104.587 194.269 104.687 193.879H167.567C167.637 194.269 167.717 194.639 167.787 195.009Z",
    fill: "black"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M168.387 198.219H103.667C103.747 197.849 103.837 197.479 103.927 197.089H168.177C168.247 197.479 168.317 197.849 168.387 198.219Z",
    fill: "black"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M168.947 201.439H102.957C103.027 201.089 103.107 200.709 103.207 200.309H168.757C168.827 200.709 168.887 201.079 168.947 201.439Z",
    fill: "black"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M169.407 204.659H102.377C102.407 204.359 102.467 203.979 102.547 203.529H169.267C169.337 203.989 169.377 204.369 169.407 204.659Z",
    fill: "black"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M151.969 207.295L162.564 162.02L166.735 121.425L188.696 127.259L207.057 123.581L223.466 130.6L246.837 125.311L231.033 168.176L224.372 211.59L206.696 215.965L188.926 208.335L170.917 214.232L151.969 207.295Z",
    fill: "#EBEBEB"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M170.917 214.232L188.696 127.259L207.057 123.581L188.926 208.335L170.917 214.232Z",
    fill: "#DBDBDB"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M206.696 215.965L223.466 130.6L246.837 125.311L231.033 168.176L224.372 211.59L206.696 215.965Z",
    fill: "#DBDBDB"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M242.44 144.71C243.168 149.013 246.371 155.007 245.866 158.212C245.411 161.106 242.809 161.432 242.809 161.432C242.809 161.432 245.465 163.848 244.528 166.681C244.046 168.138 241.294 168.648 241.294 168.648C241.294 168.648 243.338 170.678 242.35 173.145C241.562 175.111 238.923 175.328 238.923 175.328C238.923 175.328 239.976 178.188 238.532 179.934C235.602 183.474 218.108 178.528 217.228 171.319C216.817 167.959 221.025 169.4 221.025 169.4C221.025 169.4 215.475 165.868 216.402 162.235C217.329 158.602 222.683 160.803 222.683 160.803C222.683 160.803 217.335 157.333 218.676 153.664C220.073 149.844 225.051 152.963 225.051 152.963C225.051 152.963 221.906 149.226 223.577 146.652C226.335 142.402 233.51 150.734 237.612 150.909L239.706 144.761L242.44 144.71Z",
    fill: "#DD6A57"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M244.018 151.086C243.684 146.952 246.841 146.104 247.633 142.176C248.512 137.813 243.144 137.499 239.775 144.543L237.61 150.909L244.018 151.086Z",
    fill: "#DD6A57"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M238.51 175.423C238.569 175.435 238.565 175.521 238.502 175.518C232.351 175.293 225.662 173.161 220.784 169.348C220.624 169.223 220.758 168.909 220.96 169.013C226.74 171.982 232.106 174.155 238.51 175.423Z",
    fill: "#263238"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M241.369 168.709C241.439 168.722 241.417 168.838 241.341 168.835C235.004 168.569 227.537 165.961 222.431 160.904C222.256 160.731 222.273 160.399 222.489 160.584C226.139 163.688 235.598 167.597 241.369 168.709Z",
    fill: "#263238"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M224.792 152.478C229.875 157.138 235.94 159.699 242.548 161.434C242.634 161.456 242.593 161.576 242.516 161.577C239.052 161.609 234.956 160.064 231.87 158.592C228.914 157.182 226.53 155.316 224.629 152.656C224.556 152.552 224.684 152.378 224.792 152.478Z",
    fill: "#263238"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M124.01 129.416C112.353 142.342 89.754 175.696 94.099 184.546C99.953 196.471 122.149 214.252 130.095 217.156C133.524 218.41 148.278 193.555 145.11 191.273C141.309 188.536 120.193 173.509 120.401 172.101C120.599 170.761 127.247 154.445 130.873 140.12C135.079 123.504 130.411 122.319 124.01 129.416Z",
    fill: "#DD6A57"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M130.695 188.926C130.695 188.926 141.418 186.036 148.52 184.475C152.482 183.604 159.408 182.718 162.611 183.41C167.402 184.445 186.78 191.833 185.09 196.57C183.56 200.858 167.718 192.397 167.718 192.397C167.718 192.397 184.458 199.522 181.667 204.346C178.876 209.17 162.248 197.23 162.248 197.23C162.248 197.23 179.283 204.936 175.618 209.455C172.848 212.87 157.179 202.905 157.179 202.905C157.179 202.905 171.776 209.63 169.078 213.265C166.097 217.282 151.057 208.991 151.057 208.991C142.645 217.077 135.093 218.604 130.095 217.158C128.874 216.803 130.695 188.926 130.695 188.926Z",
    fill: "#DD6A57"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M162.085 189.561C164.082 190.327 166.108 191.088 168.03 192.029C169.952 192.97 171.842 193.978 173.668 195.093C178.146 197.828 180.522 200.242 180.359 200.108C176.504 196.961 169.677 193.487 167.754 192.546C165.836 191.607 163.966 190.572 162.048 189.632C161.999 189.609 162.038 189.542 162.085 189.561Z",
    fill: "#263238"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M158.563 196.438C161.07 197.526 163.599 198.514 166.059 199.714C168.507 200.907 170.725 202.254 173.084 203.612C173.266 203.717 173.15 203.78 172.963 203.682C170.551 202.419 168.224 201.437 165.798 200.202C163.38 198.971 160.992 197.637 158.532 196.496C158.494 196.478 158.525 196.422 158.563 196.438Z",
    fill: "#263238"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M154.479 201.798C158.396 203.265 162.038 205.452 165.558 207.684C165.733 207.795 165.575 207.86 165.389 207.757C161.743 205.731 158.897 204.116 154.428 201.935C154.357 201.9 154.396 201.766 154.479 201.798Z",
    fill: "#263238"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M126.174 157.596L101.453 152.673C101.453 152.673 118.864 131.102 125.775 126.203C133.553 120.69 134.671 125.873 133.225 134.818C131.779 143.765 126.174 157.596 126.174 157.596Z",
    fill: "#073C7C"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M126.394 153.279C125.563 152.982 117.871 151.385 116.192 151.074C114.512 150.763 107.66 149.426 105.899 149.249C105.821 149.241 105.793 149.347 105.87 149.37C107.558 149.872 114.466 151.24 116.17 151.592C117.874 151.944 125.52 153.355 126.382 153.395C126.454 153.399 126.45 153.299 126.394 153.279Z",
    fill: "#F5F5F5"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M140.716 118.704C135.268 118.094 128.76 122.756 133.576 129.074C138.393 135.392 143.623 136.606 146.457 135.725C149.871 134.664 151.142 127.758 150.296 124.509C149.45 121.26 145.367 119.225 140.716 118.704Z",
    fill: "#455A64"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M145.199 133.449C142.919 133.789 136.225 129.62 133.691 125.116C133.519 124.806 134.665 112.36 134.636 109.871C134.628 109.36 150.296 113.483 150.296 113.483C150.296 113.483 148.821 118.72 148.899 123.061C148.909 123.424 148.949 123.761 149.018 124.082C149.024 124.129 149.038 124.186 149.043 124.251C149.382 126.187 148.542 132.95 145.199 133.449Z",
    fill: "#DD6A57"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M135.643 109.938C136.273 113.708 138.803 124.258 147.443 124.358C148.023 124.358 148.553 124.328 149.043 124.248C149.033 124.188 149.023 124.128 149.013 124.078C148.953 123.758 148.913 123.418 148.903 123.058C148.823 118.718 150.293 113.478 150.293 113.478C150.293 113.478 139.113 110.538 135.643 109.938Z",
    fill: "#263238"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M157.539 85.7429C157.539 85.7429 162.258 88.8849 162.173 94.2889C162.088 99.6929 159.822 104.932 159.318 105.11C158.814 105.289 157.539 85.7429 157.539 85.7429Z",
    fill: "#263238"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M136.155 88.8249C133.356 93.8929 132.905 110.148 136.02 114.453C140.536 120.694 149.579 123.112 155.298 117.307C160.841 111.68 161.054 90.4849 157.42 86.4029C152.069 80.3909 140.29 81.3389 136.155 88.8249Z",
    fill: "#DD6A57"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M149.424 101.762C149.417 101.72 149.337 101.811 149.337 101.856C149.336 102.952 149.15 104.207 148.148 104.538C148.117 104.548 148.118 104.603 148.155 104.6C149.37 104.469 149.599 102.801 149.424 101.762Z",
    fill: "#263238"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M148.484 100.588C146.728 100.397 146.475 103.924 148.102 104.101C149.703 104.274 149.956 100.748 148.484 100.588Z",
    fill: "#263238"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M155.451 102.116C155.462 102.075 155.533 102.174 155.528 102.218C155.415 103.308 155.469 104.575 156.431 105.009C156.461 105.022 156.454 105.077 156.418 105.069C155.224 104.814 155.169 103.131 155.451 102.116Z",
    fill: "#263238"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M156.508 101.045C158.275 101.038 158.159 104.572 156.523 104.578C154.912 104.585 155.027 101.051 156.508 101.045Z",
    fill: "#263238"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M146.987 99.4141C147.476 99.3281 147.913 99.1661 148.387 99.0311C148.923 98.8781 149.365 98.8121 149.741 98.3681C149.942 98.1301 149.898 97.6741 149.686 97.4571C149.191 96.9511 148.488 96.9751 147.836 97.1331C147.128 97.3041 146.626 97.6171 146.186 98.1961C145.76 98.7561 146.342 99.5281 146.987 99.4141Z",
    fill: "#263238"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M158.003 98.5909C157.52 98.4759 157.093 98.2899 156.627 98.1269C156.101 97.9429 155.663 97.8509 155.314 97.3859C155.126 97.1369 155.197 96.6839 155.422 96.4789C155.946 96.0019 156.646 96.0679 157.288 96.2629C157.985 96.4749 158.468 96.8169 158.873 97.4199C159.267 98.0059 158.641 98.7429 158.003 98.5909Z",
    fill: "#263238"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M147.401 111.551C147.644 111.825 147.88 112.197 148.274 112.258C148.652 112.317 149.11 112.178 149.468 112.067C149.503 112.056 149.536 112.095 149.511 112.126C149.197 112.525 148.582 112.745 148.082 112.62C147.594 112.498 147.38 112.053 147.292 111.592C147.281 111.529 147.366 111.511 147.401 111.551Z",
    fill: "#263238"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M148.784 108.363C149.328 109.355 150.189 109.938 151.148 110.196C151.576 110.314 152.031 110.362 152.482 110.353C152.57 110.357 152.659 110.354 152.74 110.342C152.82 110.338 152.893 110.334 152.982 110.322C153.111 110.313 153.188 110.212 153.219 110.093V110.085C153.221 110.045 153.223 110.013 153.217 109.972C153.217 109.972 153.217 109.972 153.218 109.964L153.223 109.868C153.306 109.029 153.317 107.743 153.317 107.743C153.613 107.919 155.13 108.736 155.137 108.295C155.181 104.641 155.229 100.578 154.501 96.9329C154.483 96.8119 154.298 96.8259 154.3 96.9469C154.119 100.457 154.556 103.974 154.431 107.503C153.944 107.277 153.154 106.867 152.713 106.844C152.591 106.87 152.738 109.328 152.67 109.702C152.67 109.702 152.669 109.718 152.66 109.742C151.234 109.821 150.199 109.318 148.895 108.27C148.817 108.204 148.725 108.271 148.784 108.363Z",
    fill: "#263238"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M152.017 109.891C152.017 109.891 151.199 110.844 150.152 111.134C149.766 111.242 149.357 111.266 148.941 111.123C148.085 110.831 148.121 110.029 148.33 109.355C148.5 108.801 148.796 108.334 148.796 108.334C148.796 108.334 149.983 109.618 152.017 109.891Z",
    fill: "#263238"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M150.151 111.134C149.765 111.242 149.356 111.266 148.94 111.123C148.084 110.831 148.12 110.029 148.329 109.355C149.257 109.518 150.137 110.219 150.151 111.134Z",
    fill: "#FF9CBD"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M134.223 104.122C136.163 104.765 138.543 98.9399 139.229 96.6949C139.834 94.7159 140.621 88.4159 140.726 87.9869C140.831 87.5589 149.119 93.7659 154.076 92.4379C159.033 91.1089 162.424 86.7629 162.538 84.7019C162.652 82.6409 156.655 77.2669 151.37 76.8809C146.085 76.4949 138.771 83.0589 138.771 83.0589C138.771 83.0589 141.269 80.2079 141.192 79.9679C141.115 79.7269 137.665 81.0169 136.982 83.4379C136.982 83.4379 137.727 80.3959 137.47 80.3329C137.213 80.2699 134.497 82.8289 135.053 84.8269C135.053 84.8269 131.92 87.4199 131.57 90.3309C131.22 93.2429 131.943 103.367 134.223 104.122Z",
    fill: "#263238"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M157.599 91.4879C156.086 92.1429 154.569 92.867 152.909 93.049C151.115 93.245 149.269 92.754 147.618 92.079C145.93 91.389 144.403 90.408 143.023 89.218C141.814 88.176 140.749 86.929 139.454 85.996C139.13 85.763 138.738 86.228 138.934 86.535C140.864 89.576 144.341 92.157 147.723 93.313C151.281 94.529 154.667 93.8049 157.617 91.5279C157.634 91.5139 157.624 91.4769 157.599 91.4879Z",
    fill: "#263238"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M146.44 107.577C144.309 107.231 142.594 105.475 142.395 103.227C142.16 100.568 144.131 98.2149 146.789 97.9789C149.448 97.7429 151.801 99.7139 152.037 102.372C152.272 105.029 150.301 107.383 147.644 107.619C147.232 107.657 146.829 107.641 146.44 107.577ZM147.887 98.6609C147.55 98.6059 147.201 98.5919 146.846 98.6239C144.544 98.8279 142.836 100.867 143.039 103.17C143.244 105.472 145.284 107.182 147.585 106.976C149.888 106.772 151.595 104.732 151.392 102.43C151.219 100.483 149.734 98.9609 147.887 98.6609Z",
    fill: "#FFC727"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M157.538 108.008C155.71 107.711 154.356 105.57 154.467 103.048C154.523 101.775 154.939 100.59 155.638 99.7129C156.36 98.8049 157.299 98.3279 158.28 98.3719C159.265 98.4129 160.154 98.9719 160.794 99.9399C161.413 100.876 161.722 102.092 161.666 103.365C161.548 106.031 159.838 108.129 157.854 108.041C157.747 108.035 157.642 108.025 157.538 108.008ZM158.495 99.0429C158.414 99.0299 158.333 99.0209 158.251 99.0179C157.482 98.9839 156.734 99.3739 156.143 100.115C155.529 100.887 155.163 101.938 155.113 103.076C155.012 105.386 156.248 107.324 157.882 107.394C159.51 107.466 160.917 105.645 161.019 103.336C161.069 102.199 160.797 101.119 160.253 100.296C159.787 99.5899 159.17 99.1519 158.495 99.0429Z",
    fill: "#FFC727"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M151.849 102.925L151.455 102.411C152.215 101.828 153.948 101.074 155.072 102.39L154.58 102.81C153.575 101.631 151.919 102.873 151.849 102.925Z",
    fill: "#FFC727"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M131.2 103.439L130.639 103.117C130.79 102.856 132.149 100.556 133.603 100.385C134.962 100.229 142.643 101.204 143.009 101.255L142.919 101.896C140.446 101.551 134.727 100.904 133.678 101.028C132.718 101.14 131.564 102.807 131.2 103.439Z",
    fill: "#FFC727"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M136.801 102.287C136.801 102.287 134.217 96.5279 131.669 97.3549C129.122 98.1819 130.389 106.058 132.904 107.582C135.419 109.106 136.875 106.805 136.875 106.805L136.801 102.287Z",
    fill: "#DD6A57"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M132.089 99.6039C132.046 99.5919 132.026 99.6509 132.061 99.6739C133.812 100.805 134.476 102.755 134.828 104.713C134.398 103.903 133.702 103.372 132.633 103.864C132.577 103.89 132.61 103.977 132.665 103.975C133.474 103.957 134.009 104.198 134.416 104.921C134.704 105.433 134.852 106.039 135.021 106.599C135.078 106.786 135.401 106.753 135.374 106.545C135.372 106.53 135.369 106.514 135.367 106.498C135.876 104.088 134.641 100.343 132.089 99.6039Z",
    fill: "#263238"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M222.93 88.459C221.631 100.881 210.502 109.902 198.08 108.603C193.06 108.078 188.597 105.947 185.141 102.765L173.826 104.426L179.487 94.644C178.113 91.302 177.535 87.582 177.935 83.753C179.234 71.331 190.363 62.31 202.785 63.609C215.208 64.908 224.229 76.037 222.93 88.459Z",
    fill: "white"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M222.93 88.4591C222.457 92.5881 220.948 96.6361 218.365 99.9241C217.772 100.786 217.008 101.505 216.315 102.284C215.529 102.969 214.796 103.72 213.928 104.305C212.274 105.579 210.415 106.578 208.472 107.343C206.538 108.157 204.458 108.545 202.383 108.795C201.337 108.851 200.289 108.947 199.241 108.855C198.191 108.831 197.145 108.719 196.111 108.529C191.972 107.779 188.052 105.842 184.921 103.004L185.189 103.086L173.885 104.822L173.065 104.948L173.48 104.225L179.108 94.4241L179.082 94.8111C176.34 88.3551 176.958 80.6671 180.475 74.6521C182.228 71.6401 184.673 69.0451 187.559 67.1091C190.443 65.1681 193.788 63.9511 197.212 63.4871C200.64 63.0321 204.167 63.3441 207.44 64.4321C210.709 65.5331 213.706 67.3841 216.162 69.7801C221.155 74.5271 223.665 81.6481 222.93 88.4591ZM222.93 88.4591C223.617 81.6431 221.058 74.5651 216.063 69.8821C213.583 67.5401 210.581 65.7651 207.341 64.7361C204.096 63.7201 200.624 63.4781 197.282 63.9821C193.942 64.4951 190.707 65.7391 187.941 67.6721C185.182 69.6101 182.855 72.1431 181.174 75.0531C179.46 77.9571 178.572 81.2841 178.303 84.6231C178.091 87.9741 178.638 91.3651 179.895 94.4761L179.977 94.6781L179.869 94.8631L174.174 104.626L173.769 104.029L185.095 102.443L185.251 102.421L185.362 102.526C188.356 105.336 192.145 107.298 196.192 108.105C197.203 108.309 198.229 108.437 199.26 108.478C200.29 108.587 201.322 108.51 202.355 108.473C204.403 108.262 206.468 107.916 208.396 107.143C210.332 106.418 212.203 105.467 213.852 104.203C214.719 103.627 215.453 102.885 216.241 102.209C216.935 101.439 217.702 100.727 218.298 99.8731C220.893 96.6131 222.429 92.5851 222.93 88.4591Z",
    fill: "#263238"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M197.787 99.0051L188.127 89.2261L191.372 86.0191L197.015 91.7311L208.739 73.3511L212.586 75.8041L197.787 99.0051Z",
    fill: "#FFC727"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearBy);
export default __webpack_public_path__ + "static/media/NearBy.20e7a0338b06c612a7c204ca567b1451.svg";
export { ForwardRef as ReactComponent };